//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ServiceCard from "~/components/ohrany-zreniya/ServiceCard.vue";
import ServiceModal from "~/components/services/ServiceModal.vue";

export default {
  name: 'Services',
  data: function () {
    return {
      service: {},
      isOpenServiceModal: false,
      showFullServices: false,
      links: [
        {title: 'от 2 до 6 лет', url: '/zapis?step_age=2-6&step_service=40'},
        {title: 'от 7 до 12 лет', url: '/zapis?step_age=7-11&step_service=42'},
        {title: 'от 12 до 18 лет', url: '/zapis?step_age=12-18&step_service=41'},
        {title: 'старше 18 лет', url: '/zapis?step_age=19&step_service=8'},
      ]
    }
  },
  props: ['services'],
  components: {
    ServiceModal,
    ServiceCard
  },

  methods: {
    openService: async function (slug) {
      const { data: service } = await this.$api.agent.transport.get(`services/${slug}?expand=category,specialists,stores`).catch((err) => {
        return {data: null}
      });

      if (!service) {
        this.$customNotification.error("К сожаление, данной услуги нет.")

        return null
      }

      this.$refs.refServiceModal.open(service);
    },
    closeService: function () {
      this.service = {};
      this.isOpenServiceModal = false;
    }
  },
  computed: {
    shortenedServices() {
      if(this.services.length > 5 && !this.showFullServices) {
        return this.services.slice(0, 5);
      }

      return this.services
    }
  }
}


